<template>
  <div class="user-agreement">
    <div v-if="list.length" class="agreement-list">
      <div
        v-for="item in list"
        :key="item.sign_id"
        class="agreement-item"
        @click="toDetail(item)"
      >
        <span class="sign-date">签约日期：{{ item.sign_time }}</span>
        <span class="detail-link">查看详情&nbsp;&gt;</span>
      </div>
    </div>
    <van-empty v-else-if="!loading" description="暂无协议" />
  </div>
</template>

<script>
import { getAgreementList } from "@/apis/agreement";

export default {
  name: "userAgreement",
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      const loading = this.$loading();
      this.loading = true;
      try {
        const res = await getAgreementList();
        this.list = res.data || [];
      } catch (e) {
        this.list = [];
      } finally {
        this.loading = false;
        loading.clear();
      }
    },
    toDetail(item) {
      this.$router.push({
        path: "/userAgreement/detail",
        query: {
          sign_id: item.sign_id,
          name: encodeURIComponent(item.name) || "",
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user-agreement {
  min-height: 100vh;
  background: #f9fbfd;
  box-sizing: border-box;
  padding: 24px 16px;
}

.agreement-list {
  width: 100%;
}

.agreement-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-sizing: border-box;
}

.sign-date {
  color: #333;
  font-size: 12px;
  line-height: 17px;
}

.detail-link {
  color: #999;
  font-size: 10px;
  line-height: 14px;
  flex-shrink: 0;
  margin-left: 12px;
}

.empty {
  padding-top: 120px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
